import TagButton from 'components/TagButton'
import React from 'react'

interface FiltersProps {
  filter: string | undefined | null
  lpLoading: boolean
  switchFilter: (value: string) => void
}
const Filters: React.FC<FiltersProps> = ({ filter, lpLoading, switchFilter }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      <TagButton
        active={filter === 'hyped'}
        onClick={() => {
          if (lpLoading === false) {
            switchFilter('hyped')
          }
        }}
        style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="rgb(236, 159, 72)"
          stroke="rgb(233, 66, 30)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-flame"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 10.941c2.333 -3.308 .167 -7.823 -1 -8.941c0 3.395 -2.235 5.299 -3.667 6.706c-1.43 1.408 -2.333 3.621 -2.333 5.588c0 3.704 3.134 6.706 7 6.706s7 -3.002 7 -6.706c0 -1.712 -1.232 -4.403 -2.333 -5.588c-2.084 3.353 -3.257 3.353 -4.667 2.235" />
        </svg>
        Hyped Pools
      </TagButton>
      <TagButton
        active={filter === 'leverage'}
        onClick={() => {
          if (lpLoading === false) {
            switchFilter('leverage')
          }
        }}
        style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-rocket"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3" />
          <path d="M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3" />
          <path d="M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        </svg>
        Ecosystem Pools
      </TagButton>
      <TagButton
        active={filter === 'v3'}
        onClick={() => {
          if (lpLoading === false) {
            switchFilter('v3')
          }
        }}
        style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
      >
        Concentrated Liquidity
      </TagButton>
      <TagButton
        active={filter === 'v2'}
        onClick={() => {
          if (lpLoading === false) {
            switchFilter('v2')
          }
        }}
        style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
      >
        Standard AMM
      </TagButton>
      <TagButton
        active={filter === '' || filter === undefined}
        onClick={() => {
          if (lpLoading === false) {
            switchFilter('')
          }
        }}
        style={{ fontWeight: 500, height: '32px', fontSize: '14px' }}
      >
        All
      </TagButton>
    </div>
  )
}
export default Filters
